import { IArticle } from '@/interfaces/storageTracking/IArticle.ts';
import { IArticleSearchFilters } from '@/interfaces/storageTracking/IArticleSearchFilters.ts';
import { IModifySpecificInfoPostObject } from '@/interfaces/storageTracking/IModifyInfoPostObject.ts';
import { IDateRange } from '@/interfaces/general/IDateRange.ts';
import { INewsFeed } from '@/interfaces/storageTracking/INewsfeed.ts';

import { useApi } from '../useApi.ts';

const apiCall = useApi('storageTracking');

function parseAndSetArticleDate (article: IArticle): void {
    const [day, month, year] = article.articleIdentifiers.date.split('/').map(Number);
    article.date = new Date(year, month - 1, day);
}

async function getArticles (dateRange: IDateRange): Promise<Array<IArticle>> {
    const data = (await apiCall.post<IDateRange, Array<IArticle>>({
        endpoint: '/ArticleScraping/getLatestArticles',
        payload: dateRange,
    })).data;

    data.forEach(parseAndSetArticleDate);
    return data;
}

async function getNewsfeedNames (): Promise<Array<string>> {
    return (await apiCall.get<Array<string>>({ endpoint: '/ArticleScraping/getNewsfeedPageSetup' })).data;
}

async function getFilteredArticles (filters: IArticleSearchFilters): Promise<Array<IArticle>> {
    const data = (await apiCall.post<IArticleSearchFilters, Array<IArticle>>({
        endpoint: '/ArticleScraping/getFilteredArticles',
        payload: filters,
    })).data;

    data.forEach(parseAndSetArticleDate);
    return data;
}

async function getArticlesForFactStorageId (factStorageIdForProject: string): Promise<Array<IArticle>> {
    const data = (await apiCall.post<{ factStorageId: string }, Array<IArticle>>({
        endpoint: '/ArticleScraping/getAllArticlesForProject',
        payload: { factStorageId: factStorageIdForProject },
    })).data;

    data.forEach(parseAndSetArticleDate);
    return data;
}

async function rematchAllArticles () : Promise<string> {
    return (await apiCall.get<string>({ endpoint: '/ArticleScraping/matchScrapedProjects' })).data;
}

async function deleteItemFromArticleDb (idToDelete: string): Promise<string> {
    return (await apiCall.post<{ articleDbId: string }, string>({
        endpoint: '/ArticleScraping/deleteItemFromArticleDb',
        payload: { articleDbId: idToDelete },
    })).data;
}

async function modifySpecificInfo (updatedScrapedInfo: IModifySpecificInfoPostObject): Promise<string> {
    return (await apiCall.post<IModifySpecificInfoPostObject, string>({
        endpoint: '/ArticleScraping/modifySpecificInfo',
        payload: updatedScrapedInfo,
    })).data;
}

async function addNewNewsfeed (newsfeedsToAdd: INewsFeed): Promise<string> {
    return (await apiCall.post<INewsFeed, string>({
        endpoint: '/ArticleScraping/addNewNewsfeed',
        payload: newsfeedsToAdd,
    })).data;
}

async function getScrapedArticleData (dateRange: IDateRange): Promise<Array<Array<string>>> {
    return (await apiCall.post<IDateRange, Array<Array<string>>>({
        endpoint: '/ArticleScraping/getScrapedArticleData',
        payload: dateRange,
    })).data;
}

export const articleScrapingApi = {
    addNewNewsfeed,
    getArticles,
    getArticlesForFactStorageId,
    getFilteredArticles,
    getNewsfeedNames,
    getScrapedArticleData,
    rematchAllArticles,
    modifySpecificInfo,
    deleteItemFromArticleDb,
};
